<template>
  <div class="chat-container">
    <iframe :src="iframeURL" height="100%" width="100%"></iframe>
  </div>
</template>
<script>
import { TwitchParent } from '../api';
export default {
  props: ['channel'],
  computed: {
    iframeURL(){
      return `https://www.twitch.tv/embed/${this.channel}/chat?parent=${TwitchParent}&darkpopout`;
    }
  },
}
</script>
<style scoped>
  .chat-container{
    position: absolute;
    width: 350px;
    height: 100%;
    top: 0;
    right: 0;
    overflow: hidden;
  }
</style>

